import { render, staticRenderFns } from "./DataSetoran.vue?vue&type=template&id=3b4e533e&"
import script from "./DataSetoran.vue?vue&type=script&lang=js&"
export * from "./DataSetoran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports